import React from 'react';
import classNames from 'classnames';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import Button from './Button';

export default function Arrows({
  onRightClick,
  onLeftClick,
  leftActive,
  rightActive,
}) {
  return (
    <div className={classNames('flex flex-row gap-1')}>
      <Button
        size="wrapped"
        variant="ghost"
        disabled={!leftActive}
        onClick={onLeftClick}
        ariaLabel="Arrow Left"
      >
        <ArrowLeft />
      </Button>

      <Button
        size="wrapped"
        variant="ghost"
        disabled={!rightActive}
        onClick={onRightClick}
        ariaLabel="Arrow Left"
      >
        <ArrowRight />
      </Button>
    </div>
  );
}
